import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/state'
import { patchCurrentUser } from 'src/state/users'
import { UserPatchType } from '@meniudigital/shared'
import Setting from '../Setting'

export default function PartyModeSetting() {
  const dispatch = useDispatch()
  const { user } = useSelector((state: State) => state.users)

  if (!user) {
    return null
  }

  const confirmIsUsingPartyMode = async () => {
    if (!user.isUsingPartyMode) {
      await window.showModal({
        title: `Activare câmp "Preț Eveniment"`,
        text: `Ești sigur că dorești afișarea câmpului "Preț Eveniment" pe produse?`,
        confirmButtonText: 'Da, afișează',
        cancelButtonText: 'Nu',
      })
    }
  }

  const toggleIsUsingPartyMode = () => {
    const payload = {
      type: UserPatchType.IsUsingPartyMode,
      data: !user.isUsingPartyMode,
    }
    dispatch(patchCurrentUser(payload as any))
  }

  const confirmPartyMode = async () => {
    if (!user.inPartyMode) {
      await window.showModal({
        title: `Activare Mod "Eveniment"`,
        text: `Ești sigur că dorești activarea modului "Eveniment"?`,
        confirmButtonText: 'Da, activează',
        cancelButtonText: 'Nu',
      })
    } else {
      await window.showModal({
        title: `Dezactivare Mod "Eveniment"`,
        text: `Ești sigur că dorești dezactivarea modului "Eveniment"?`,
        confirmButtonText: 'Da, dezactivează',
        cancelButtonText: 'Nu',
      })
    }
  }

  const togglePartyMode = () => {
    const payload = {
      type: UserPatchType.InPartyMode,
      data: !user.inPartyMode,
    }
    dispatch(patchCurrentUser(payload as any))
  }

  return (
    <>
      <div className="settings-group">
        <Setting
          title='Editare "Preț Eveniment" pe Produse'
          iconPath="/icons/pencil.png"
          isEnabled={user?.isUsingPartyMode}
          onBeforeToggle={confirmIsUsingPartyMode}
          onToggle={toggleIsUsingPartyMode}
          toggleTexts={{ on: 'Vizibil', off: 'Ascuns' }}
        />

        <Setting
          title='Modul "Eveniment"'
          iconPath="/icons/calendar-star.png"
          isEnabled={user?.inPartyMode}
          onBeforeToggle={confirmPartyMode}
          onToggle={togglePartyMode}
          toggleTexts={{ on: 'Activ', off: 'Inactiv' }}
          infoText={
            user?.inPartyMode
              ? 'Se afișează clienților prețurile din câmpul "Preț Eveniment"'
              : 'Prin modul "Eveniment", poți activa un preț alternativ al tuturor produselor tale cu un singur click (pentru atunci când ai un eveniment special de exemplu).'
          }
          infoVariant={user?.inPartyMode ? 'warning' : undefined}
          withBullet
        />
      </div>
    </>
  )
}
